import React from 'react';

// FIX: Define ModelType locally as it was not exported from App.tsx.
type ModelType = 'bagdaunov' | 'transformer';

interface ModelSelectorProps {
  selectedModel: ModelType;
  onModelChange: (model: ModelType) => void;
}

const models: { id: ModelType; name: string }[] = [
  { id: 'bagdaunov', name: 'Bagdaunov Attention' },
  { id: 'transformer', name: 'Transformers' },
];

const ModelSelector: React.FC<ModelSelectorProps> = ({ selectedModel, onModelChange }) => {
  return (
    <div className="flex items-center justify-center p-1 bg-gray-100 rounded-full shadow-inner" role="radiogroup" aria-label="Translation Model">
      {models.map((model) => (
        <div key={model.id} className="relative group flex items-center">
          <button
            onClick={() => onModelChange(model.id)}
            className={`px-4 sm:px-6 py-2 rounded-full text-sm font-semibold transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-pink-400 focus:ring-offset-2
              ${
                selectedModel === model.id
                  ? 'bg-pink-500 text-white shadow-sm'
                  : 'bg-transparent text-gray-600 hover:bg-gray-200'
              }`}
            role="radio"
            aria-checked={selectedModel === model.id}
            aria-describedby={model.id === 'transformer' ? 'transformer-tooltip' : undefined}
          >
            {model.name}
          </button>
          {model.id === 'transformer' && (
            <span
              id="transformer-tooltip"
              role="tooltip"
              className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-max whitespace-nowrap
                         bg-gray-700 text-white text-xs font-medium rounded-md py-1 px-3
                         opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
            >
              "Transformers" based translator is coming soon
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default ModelSelector;